import Vue from 'vue';
import { replaceUrl } from '@/util';

Vue.directive('link', function(el, binding) {
  let value = binding.value || '';
  if (!value) return;
  value = value.replaceAll('\\n', '\n');
  el.innerHTML = replaceUrl(value, binding.modifiers.escape);
});
